import { authHeader, handleResponse } from './helper';
import config from '../config';

const sendPatientForm = async (params, countryCode) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      'country_code': countryCode?.toUpperCase()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/exams/${params.document_type}/${params.document_number}/surveys/answers`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getQuestionsAnswers = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiUrl}/admissionQuestionResults/${params.idAdmissionPatientExam}/admissionQuestionResutls`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const updateQuestionsAnswers = (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/admissionQuestionResults/${params.admissionPatientExam}/admissionQuestionResutls/update`);
  return fetch(url, requestOptions).then(handleResponse);
};

const updateProcedureResults = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiUrl}/admissionProcedureResults/${params.admissionPatientExam}/admissionProcedureResutls/update`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const markSurveyAsPendingSubmission = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      admission_patient_exam_id: params.admissionPatientExamId,
      user_id: params.userId
    })
  };

  const url = new URL(`${config.apiUrl}/exams/markSurveyAsPendingSubmission`);
  return await fetch(url, requestOptions).then(handleResponse);
};


export const revisionService = {
  sendPatientForm,
  getQuestionsAnswers,
  updateQuestionsAnswers,
  updateProcedureResults,
  markSurveyAsPendingSubmission
}